// Angular Modules
import { Injectable, inject, signal } from '@angular/core';
// import { IAuthApiResponse, Logging } from '../../../../shared/src/import-export';
import { Router } from '@angular/router';
import { IAuthApiResponse } from '../library/interfaces';
// import Logging from '../library/logging';
// import { IUserRole } from '../../../../shared/src/import-export';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private tokenTimer: any | undefined;

  crudLoader = signal<boolean>(false);
  authState = signal<IAuthApiResponse | undefined | null>(null);

  _router = inject(Router);

  featureOff(featureName: string) {
    return !this.featureOn(featureName);
  }

  featureOn(featureName: string) {
    if (!featureName) {
      return true;
    }

    return (
      this.authState()?.user.role &&
      !!(this.authState()?.user.role as string));
  }

  hasRouteAccess(featureName: string) {
    return (this.authState()?.user.role as string)
  }

  redirectUrl: string;
  getRedirectUrl() {
    const redirectUrl = localStorage.getItem('redirectUrl');
    // localStorage.removeItem('redirectUrl');
    return redirectUrl || '/';
  }

  setRedirectUrl(url: string) {
    this.redirectUrl = url
    localStorage.setItem('redirectUrl', url);
  }


  setAuthUser = (authResponse: IAuthApiResponse) => {
    if (!authResponse.error) {
      const expiresAt = authResponse.expires_in_sec * 1000;
      if (expiresAt > 10000) {
        this.authState.update(() => authResponse);
        localStorage.setItem('token', authResponse.token);
        this.setAuthTimer(expiresAt);
        console.log('redirectUrl', localStorage.getItem('redirectUrl'))
        if (localStorage.getItem('redirectUrl')) {
          console.log('setAuthUser has redirectUrl')
          this._router.navigateByUrl(localStorage.getItem('redirectUrl'));
          localStorage.removeItem('redirectUrl')
        } else {
          console.log('setAuthUser dont have redirectUrl')
          this._router.navigate(['app']);
        }
      } else {
        // this.logout();
      }
    } else {
      console.log(localStorage.getItem('redirectUrl'))
      // this.logout();
    }
  };

  private setAuthTimer(expiresInDurationMS: number) {
    // Logging.warning(
    //   'setAuthTimer',
    //   `Setting Auth Timer -> Session will expire at : ${new Date(
    //     new Date().getTime() + expiresInDurationMS
    //   )}`
    // );
    this.tokenTimer = setTimeout(() => {
      this.logout();
    }, expiresInDurationMS);
  }

  logout() {
    console.log('logout', new URL(window.location.href).origin);
    localStorage.removeItem('token');
    this.authState.set(undefined);
    clearTimeout(this.tokenTimer!);

    const url = new URL(window.location.href)
    if (url.pathname != '/')
      this._router.navigate(['/']).then(() => {
        // window.location.reload();
      });
  }
}
